<template>
  <div class="base-container-frame">
    <el-container>
      <el-aside width="auto">
        <zwx-scrollbar-y style="height: 100%;">
          <side-menu ref="menuAside" @menuSelectHandler="menuSelectHandler" :layout="layout"
                      :default-home="defaultHome" :menu-resource="menuResource" :init-menu="initMenu"/>
        </zwx-scrollbar-y>
      </el-aside>
      <el-main>
        <page-frame ref="pageFrame" @tabSelect="tabSelect" :layout="layout" @menuJump="menuJump"/>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SideMenu from '../components/navigation/side-menu/SideMenu.vue'
import PageFrame from './page-frame/PageFrame.vue'

export default {
  name: 'BaseContainer',
  props: ['userRole', 'layout', 'defaultHome', 'menuResource', 'initMenu'],
  components: {
    SideMenu,
    PageFrame
  },
  created() {
  },

  mounted() {
  },
  computed: {},
  methods: {
    menuJump(name) {
      this.$refs.menuAside.menuSelect(name)
    },
    //菜单选择切换tab
    menuSelectHandler(name, title, content, refresh) {
      this.$refs.pageFrame.menuTabs(name, title, content, refresh)
    },
    //tab选择切换菜单选中状态
    tabSelect(name) {
      this.$refs.menuAside.tabMenu(name)
    },
  },
}
</script>
